import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import {
  DELETE_TIMESHEET_DOCUMENT,
  INSERT_TIMESHEET_DOCUMENT,
  SELECT_TIMESHEET_DOCUMENT,
} from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";

/* Documents already attached to a timesheet (edit mode). */
export const getTimesheetDocuments = async (cookiesData, dispatch, timesheetMstrKey) => {
  if (!cookiesData || !timesheetMstrKey) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_transaction_src_mstr_key: timesheetMstrKey,
      in_filter: null,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
    };

    const response = await POSTAPI(false, SELECT_TIMESHEET_DOCUMENT, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching timesheet documents:", error);
    return [];
  }
};

/*
 * Uploads one file and binds it to every timesheet key it is given.
 *
 * The bulk flow creates many timesheets from one form, and a single attachment
 * belongs to all of them — hence `in_transactionsrcmstrkey` is a JSON-encoded
 * array here, matching the mobile client. The upload directory travels as the
 * `uploadpath` header, not as a body field.
 */
export const uploadTimesheetDocument = async (
  cookiesData,
  dispatch,
  { file, timesheetKeys, uploadPath, onProgress }
) => {
  if (!cookiesData || !file) return { status: false };

  try {
    const formData = new FormData();
    formData.append(
      "in_transactionsrcmstrkey",
      Array.isArray(timesheetKeys) ? JSON.stringify(timesheetKeys) : timesheetKeys
    );
    formData.append("file", file);

    const uploadHeaders = {
      "x-access-token": cookiesData.secretToken,
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      uploadpath: `${uploadPath || ""}/timesheets/`,
    };

    onProgress?.(0);
    const response = await POSTAPI(false, INSERT_TIMESHEET_DOCUMENT, null, uploadHeaders, formData, dispatch);
    onProgress?.(100);

    const retCode = response?.data?.out_parameters?.out_ret_code;
    return { status: retCode === API_CONSTANTS.SUCCESS_CODE };
  } catch (error) {
    console.error("Error uploading timesheet document:", error);
    onProgress?.(0);
    return { status: false };
  }
};

export const deleteTimesheetDocument = async (cookiesData, dispatch, documentMstrKey) => {
  if (!cookiesData || !documentMstrKey) return { status: false };

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_user_id: cookiesData.out_user_id,
      in_tenant_id: cookiesData.out_tenant_id,
      in_document_mstr_key: documentMstrKey,
    };

    const response = await POSTAPI(false, DELETE_TIMESHEET_DOCUMENT, null, apiHeaders, requestBody, dispatch);
    const retCode = response?.data?.out_parameters?.out_ret_code;

    return { status: retCode === API_CONSTANTS.SUCCESS_CODE };
  } catch (error) {
    console.error("Error deleting timesheet document:", error);
    return { status: false };
  }
};
